import React, { useState } from 'react';

import sadIcon from 'assets/svg/sad.svg';
import attentionIcon from 'assets/svg/attention.svg';
import successIcon from 'assets/svg/success.svg';

import styles from './styles.module.scss';
import { PrimaryPinkButton } from 'components/buttons/PrimaryPinkButton';
import { SecondPinkButton } from 'components/buttons/SecondPinkButton';

const icon = {
  sad: sadIcon,
  attention: attentionIcon,
  success: successIcon,
};

export function AttentionModal({
  title,
  description,
  confirmBtnText,
  type,
  onConfirm,
  onCloseModal,
}) {
  const [isLoading, setIsLoading] = useState(false);

  if (!icon[type]) {
    throw new Error('Invalid icon type: ' + type);
  }

  const handleConfirm = () => {
    if (onConfirm) {
      try {
        setIsLoading(true);
        onConfirm();
      } catch (e) {
        throw new Error(e);
      } finally {
        setIsLoading(false);
      }
    }
    onCloseModal();
  };

  const handleCancel = () => {
    onCloseModal();
  };

  return (
    <div id={styles.attentionModal}>
      <div className={styles.modalWrapper}>
        <img className={styles.icon} src={icon[type]} alt={title} />
        <h1 className={styles.title}>{title}</h1>

        {type !== 'success' && (
          <p className={styles.description}>{description}</p>
        )}
      </div>
      <div className={styles.modalButtons}>
        <PrimaryPinkButton onClick={handleConfirm} disabled={isLoading}>
          {isLoading ? 'Aguarde' : confirmBtnText}
        </PrimaryPinkButton>
        {type === 'attention' && (
          <SecondPinkButton onClick={handleCancel}>Voltar</SecondPinkButton>
        )}
      </div>
    </div>
  );
}
